import React, { Fragment } from "react";
import Navigation from "../../components/Navigation";
import FooterLanding from "../../components/FooterLanding";
import GoogleLoginButton from "../../components/GoogleLoginButton";
import FormNuevoProspecto from "../../components/FormNuevoProspecto";
import useUser from "../../hooks/useUser";
import swal from "sweetalert2";
import PropTypes from "prop-types";

const SOURCE =
	new URLSearchParams(window.location.search).get("source") || "feria2026";
const VIGENCIA = "31 de diciembre de 2026";
const WHATSAPP_AGENDA = "https://wa.link/yk1i4u";

const PromoCard = ({ icon, title, children }) => (
	<div className="shadow bg-1 p-4 rounded text-center h-100">
		<i className={`fas ${icon} font-xl color-3 mb-3`}></i>
		<h4 className="bold">{title}</h4>
		<p className="color-2 mb-0">{children}</p>
	</div>
);

PromoCard.propTypes = {
	icon: PropTypes.string,
	title: PropTypes.string,
	children: PropTypes.any
};

export default function Promocion() {
	const { user } = useUser();
	return (
		<div className="PromoFeria">
			<Fragment>
				<Navigation />
				<main>
					<header
						className="page header color-1 overlay alpha-8 image-background cover gradient gradient-43"
						style={{ backgroundImage: "url('images/landing/bg/waves.jpg')" }}
					>
						<div className="container pb-9">
							<div className="row">
								<div className="col-md-8">
									<h1 className="regular display-4 color-1 mb-4">
										3 formas de impulsar tu empresa con LifeChain
									</h1>
									<p className="lead color-1">
										Certifica documentos gratis, participa por un diagnóstico de
										IA sin costo, o agenda el tuyo hoy con 50% de descuento.
									</p>
								</div>
							</div>
						</div>
					</header>

					<section className="section mt-7n">
						<div className="container bring-to-front pt-0">
							<div className="row gap-y">
								<div className="col-md-4">
									<PromoCard icon="fa-file-signature" title="3 certificaciones gratis">
										Regístrate en la feria y certifica al instante que tus
										documentos existían en una fecha y no han sido alterados.
									</PromoCard>
								</div>
								<div className="col-md-4">
									<PromoCard icon="fa-gift" title="Sorteo: diagnóstico de IA">
										Participa gratis al registrarte. Si no ganas, te llevas 25%
										de descuento en tu diagnóstico.
									</PromoCard>
								</div>
								<div className="col-md-4">
									<PromoCard icon="fa-calendar-check" title="Agenda ya: 50% off">
										Sin esperar al sorteo: agenda tu diagnóstico de IA con 50%
										de descuento, solo durante octubre.
									</PromoCard>
								</div>
							</div>
						</div>
					</section>

					<section className="section">
						<div className="container">
							<div className="section-heading text-center mb-5">
								<p className="light mb-0 accent lead">Promociones 1 y 2</p>
								<h2>Dos beneficios, cada uno por su cuenta</h2>
								<p className="color-2">No necesitas uno para acceder al otro.</p>
							</div>
							<div className="row gap-y">
								<div className="col-md-6">
									<div className="shadow bg-1 p-4 rounded h-100 text-center">
										<i className="fas fa-file-signature font-xl color-3 mb-3"></i>
										<h4 className="bold">3 certificaciones gratis</h4>
										<p className="color-2">
											Solo necesitas entrar con tu cuenta de Google y listo,
											las verás disponibles en tu portal al instante.
										</p>
										{user ? (
											<p className="color-3 bold mb-0">
												<i className="fas fa-check mr-2"></i>
												¡Ya activaste tus certificaciones!
											</p>
										) : (
											<GoogleLoginButton
												source={SOURCE}
												onSuccess={() => {}}
											/>
										)}
									</div>
								</div>
								<div className="col-md-6">
									<div className="shadow bg-1 p-4 rounded h-100">
										<div className="text-center mb-3">
											<i className="fas fa-gift font-xl color-3 mb-3"></i>
											<h4 className="bold">Sorteo: diagnóstico de IA</h4>
											<p className="color-2">
												Llena el formulario para participar. Si no ganas, te
												llevas 25% de descuento de todas formas.
											</p>
										</div>
										<FormNuevoProspecto onSuccess={() => {
											swal.fire("¡Listo, ya estás participando!", 'Quedaste registrado en el sorteo del diagnóstico de IA. Te escribiremos pronto.', 'success')
										}} />
									</div>
								</div>
							</div>
							<p className="color-2 italic text-center mt-4 mb-0">Promociones vigentes hasta el {VIGENCIA}.</p>
						</div>
					</section>

					<section className="section bg-1 edge top-left b-b">
						<div className="container pt-5">
							<div className="d-flex align-items-center flex-column flex-md-row">
								<div className="col-md-8 text-center text-md-left">
									<p className="light mb-0 accent lead">Promoción 3 · solo octubre</p>
									<h2 className="mt-0">¿No quieres esperar al sorteo?</h2>
									<p className="color-2 mb-0">
										Agenda tu diagnóstico de IA ahora mismo y obtén 50% de
										descuento, válido únicamente durante octubre.
									</p>
								</div>
								<a
									href={WHATSAPP_AGENDA} target="_blank" rel="noreferrer"
									className="col-md-4 btn gradient gradient-42 color-1 btn-rounded btn-outline-1 bw-2 bold mt-4"
								>
									Agendar por WhatsApp
								</a>
							</div>
						</div>
					</section>
				</main>
				<FooterLanding />
			</Fragment>
		</div>
	);
}
